"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACK_USER_EVENT = void 0;
var TRACK_USER_EVENT = exports.TRACK_USER_EVENT = 'TRACK_USER_EVENT';